import React from "react"

export default function Heart() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
         <path d="M10.4943 0C7.93811 0 6.99893 2.84731 6.99893 2.84731C6.99893 2.84731 6.07258 0 3.49888 0C1.56453 0 -0.640503 1.671 0.173841 5.46952C0.988185 9.26805 7.00593 14 7.00593 14C7.00593 14 13.0015 9.26805 13.817 5.46952C14.6314 1.671 12.585 0 10.4943 0V0Z" fill="#ABACB3" />
      </svg>
   )
}
